import styled from "@emotion/styled";
import {
  SECONDARY_GREY,
  PRIMARY_FONT,
  SECONDARY_FONT,
  HEADING,
  LIGHT_BACKGROUND,
  BACKGROUND_LIGHT,
  PRIMARY_BLUE,
} from "src/constants/colors";

export const DetailContainer = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  background: none;
  border: none;
  cursor: pointer;
  color: ${SECONDARY_FONT};
  font-size: 16px;

  &:hover {
    color: ${PRIMARY_FONT};
  }
`;

export const EmailDetails = styled.div`
  margin-bottom: 24px;
`;

export const SubjectHeader = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: ${HEADING};
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const DetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DetailRow = styled.div`
  display: flex;
  gap: 16px;
`;

export const DetailLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${SECONDARY_FONT};
  min-width: 60px;
`;

export const DetailValue = styled.span`
  font-size: 14px;
  color: ${PRIMARY_FONT};
`;

export const MessageSection = styled.div`
  margin-top: 16px;
`;

export const MessageLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${SECONDARY_FONT};
  display: block;
  margin-bottom: 8px;
`;

export const MessageContent = styled.div`
  font-size: 14px;
  color: ${PRIMARY_FONT};
  line-height: 1.5;
  padding: 12px;
  background-color: ${LIGHT_BACKGROUND};
  border-radius: 6px;
  border: 1px solid ${SECONDARY_GREY};
  white-space: pre-wrap;
`;

export const AttachmentsSection = styled.div`
  flex: 1;
`;

export const AttachmentsHeader = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: ${HEADING};
`;

export const NoAttachmentsMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: ${SECONDARY_FONT};
  font-style: italic;
`;

export const AttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AttachmentItem = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${SECONDARY_GREY};
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ selected }) =>
    selected ? PRIMARY_BLUE : BACKGROUND_LIGHT};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ selected }) =>
      selected ? PRIMARY_BLUE : BACKGROUND_LIGHT};
    border-color: ${PRIMARY_BLUE};
  }
`;

export const AttachmentInfo = styled.div`
  flex: 1;
`;

export const AttachmentName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${PRIMARY_FONT};
  margin-bottom: 2px;
`;

export const AttachmentMeta = styled.div`
  font-size: 12px;
  color: ${SECONDARY_FONT};
`;
